import axios from 'axios';
import moment from 'moment';

export default {
  fetchAutomationsLog: ({ commit, getters }, { automationId = 0, timestampStart = 0, onSuccess } = {}) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    const timestamp = parseInt(moment().format('X'), 10);
    const defaultStartTimestamp = timestamp - 86400;
    const arrQuery = [];
    const payload = {
      startTimestamp: timestampStart === 0 ? defaultStartTimestamp : timestampStart,
      automationId: automationId
    };
    if (timestampStart === 0) {
      const filteredTimeFrames = getters.automationsLogTimeFrames.filter(item => {
        return item.tag === getters.automationsLogFilters.timeFrameTag;
      });
      if (filteredTimeFrames.length === 1) {
        const { startOffset } = filteredTimeFrames[0];
        payload['startTimestamp'] = timestamp - startOffset;
      }
    }
    Object.keys(payload).forEach(key => {
      if (payload[key] !== null) {
        arrQuery.push(`${key}=${payload[key]}`);
      }
    });

    const query = arrQuery.length > 0 ? `?${arrQuery.join('&')}` : '';
    axios({
      url: `/engine/log/automations${query}`,
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        commit('log/SET_AUTOMATIONS_LOG', response.data, { root: true });
        if (typeof onSuccess === "function") {
          onSuccess(response.data);
        }
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  }
};